import axios from "axios";
import { authAction } from "../redux/auth-slice";
import { store } from "../redux/store";

axios.defaults.params = {};

const authInterceptor = () =>
   axios.interceptors.request.use(
      (request) => {
         const { access_token } = store.getState().auth.tokenData;
         if (
            request.url.includes("oauth") ||
            request.url.includes("forgot-password") ||
            request.url.includes("auth/logout") ||
            request?.url?.includes("api.cloudinary.com")
         ) {
            return request;
         }

         request.params["access_token"] = access_token;
         return request;
      },
      (error) => {
         return Promise.reject(error);
      }
   );

const errorInterceptor = () =>
   axios.interceptors.response.use(
      (response) => response,
      async (err) => {
         if (err.request.responseURL?.includes("api.cloudinary.com")) {
            return Promise.reject(err);
         }
         if (err.response.status !== 401) {
            return Promise.reject(err);
         }

         if (!err.config.url.includes("refresh_token")) {
            const data = await handleRefreshToken();
            store.dispatch(authAction.setTokenData(data));
            axios.defaults.params.access_token = data.access_token;
            return axios(err.config);
         }

         store.dispatch(authAction.resetAuthData());

         return Promise.reject(err);
      }
   );

const handleRefreshToken = async () => {
   const { refresh_token } = store.getState().auth.tokenData;

   const headers = {
      Authorization: "Basic dXJiY3NydmlkOnNlY3JldEAxMjM=",
      "Content-Type": "application/json",
   };
   // eslint-disable-next-line no-undef
   const url = `${process.env.REACT_APP_URBC_API}oauth/token?refresh_token=${refresh_token}&grant_type=refresh_token`;

   const config = {
      url,
      method: "post",
      data: {},
      headers,
   };

   try {
      const response = await axios(config);
      return response.data;
   } catch (err) {
      return Promise.reject(err);
   }
};

export const interceptors = {
   authInterceptor,
   errorInterceptor,
};
